import getWindowConfiguration from './getWindowConfiguration';

export default function openStandardWindow(windowOptions) {
  const {
    specs,
    options: { url, target },
  } = getWindowConfiguration(windowOptions);
  return window.open(url, target, specs);
}
